/**
 * Futuristic confirm delete modal (on-brand)
 */

import React from 'react';
import { Trash2 } from 'lucide-react';
import ConfirmModal from '@/components/ui/ConfirmModal';

interface ConfirmDeleteModalProps {
  profileName: string;
  onConfirm: () => Promise<void> | void;
  onCancel: () => void;
  loading?: boolean;
}

const ConfirmDeleteModal: React.FC<ConfirmDeleteModalProps> = ({ profileName, onConfirm, onCancel, loading }) => {
  return (
    <ConfirmModal
      title="Delete Profile"
      subtitle="This action cannot be undone"
      onCancel={onCancel}
      onConfirm={onConfirm}
      loading={loading}
      confirmLabel="Delete"
      tone="danger"
      icon={<Trash2 className="w-5 h-5 text-red-400" />}
    >
      Are you sure you want to delete the profile
      <span className="text-cyan-400"> {profileName} </span>?
      <div className="text-white/40 font-mono text-xs mt-2">
        Any executions referencing it will fall back to your active default profile.
      </div>
    </ConfirmModal>
  );
};

export default ConfirmDeleteModal;


